import { useEffect, useRef, useState } from "react";
import PageTitle from "../components/PageTitle";
import Index from "../view/TermsConditions/Index";
import HomeIcon from "../components/Iocns/HomeIcon";
import ApiCall from "../common/ApiCall";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSlugByLang } from "../common/Helper";

export default function TermsConditionController() {
    const user = useSelector((state) => state.user);
    const userLang = getSlugByLang(user?.language)
    const [breadcrumbList, setBreadcrumbList] = useState([
        {
            name: <HomeIcon />,
            url: '/' + userLang
        },
        {
            name: "Terms and Conditions"
        },
    ])

    const [pageDetails, setPageDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const descriptionRef = useRef(null);
    const navigate = useNavigate();

    const getRecordDetails = async () => {
        setIsLoading(true)
        const fetchrecordDetail = await ApiCall('get', 'cms/terms-and-conditions',)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setPageDetails(fetchrecordDetail.data.data)
                setIsLoading(false)

            } else {
                navigate('/')
            }
        } else {
            navigate('/')
        }
    };
    useEffect(() => {
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: "/" + userLang
            },
            {
                name: "Terms and Conditions"
            },
        ])
    }, [user?.language]);

    useEffect(() => {
        (async () => {
            await getRecordDetails()
        })();
    }, []);
    return (
        <>
            <PageTitle
                title={pageDetails?.name ?? undefined}
                metaTitle={pageDetails?.meta_title ?? undefined}
                metaKeyword={pageDetails?.meta_keyword ?? undefined}
                metaDescription={pageDetails?.meta_description ?? undefined}
            />
            <Index
                breadcrumbList={breadcrumbList}
                pageDetails={pageDetails}
                descriptionRef={descriptionRef}
                isLoading={isLoading}

            />
        </>
    )

}